import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import PropertyManagementModal from './modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { USD } from 'helpers/formatters/number_formats';

export function PropertyManagementTable({
  allowPropertyManagementDeals,
  isParentCompanyUser,
  propertyManagementGrossCommissionTotal,
  propertyManagementRoyaltyPercent,
}) {
  const [showModal, setShowModal] = useState();

  return <React.Fragment>
    <h3>Property Management</h3>
    <table className="table royalty-settings-table">
      <thead>
        <tr>
          <th>Status</th>
          <th className="text-right">YTD Gross Commission</th>
          <th className="text-right">Royalty Percentage</th>
          {isParentCompanyUser && <th className="actions" width="1">Actions</th>}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>{allowPropertyManagementDeals ? 'Enabled' : 'Disabled'}</td>
          <td className="text-right">
            {USD.format(propertyManagementGrossCommissionTotal)}
          </td>
          <td className="text-right">
            {propertyManagementRoyaltyPercent ? `${propertyManagementRoyaltyPercent}%` : '--'}
          </td>
          {isParentCompanyUser &&
            <td className="actions" width="1">
              <a className="clickable" name="show-modal-link" onClick={() => setShowModal(true)}>
                <FontAwesomeIcon fixedWidth icon={faEdit} /> Edit
              </a>
            </td>}
        </tr>
      </tbody>
    </table>
    <PropertyManagementModal show={showModal} onClose={() => setShowModal(false)} />
  </React.Fragment>;
}

PropertyManagementTable.propTypes = {
  allowPropertyManagementDeals: PropTypes.bool,
  isParentCompanyUser: PropTypes.bool,
  propertyManagementGrossCommissionTotal: PropTypes.number,
  propertyManagementRoyaltyPercent: PropTypes.number,
};

const mapStateToProps = ({ isParentCompanyUser, propertyManagement }) => ({
  allowPropertyManagementDeals: propertyManagement.allowDeals,
  isParentCompanyUser,
  propertyManagementGrossCommissionTotal: propertyManagement.grossCommissionTotal,
  propertyManagementRoyaltyPercent: propertyManagement.royaltyPercent,
});

export default connect(mapStateToProps)(PropertyManagementTable);
